<template>
  <div class="bg-white flex flex-col p-4 sm:p-10 rounded-lg border border-gray-100 shadow-sm mx-2 sm:mx-10 lg:mx-20 my-6">
       <h1 class="text-xl sm:text-2xl font-semibold text-gray-900 mb-5 text-left">Showing results for: {{search_value}}</h1>


<!--    'retailer_id',-->
<!--    'staff_email',-->
<!--    'name',-->
<!--    'business_name',-->
<!--    'email',-->
<!--    'phone',-->
<!--    'address'-->

<!--    showAddCustomerAccount-->
<!--    add_customer_account_model-->

    <add_customer_account_model
        v-if="showAddCustomerAccount"
        :selected_retailer="selected_retailer"
        @completeTransaction_add_customer_account="completeTransaction_add_customer_account"
        @cancelTransaction_add_customer_account="cancelTransaction_add_customer_account"

    />


        <edit_retailer_model
            v-if="showRetailerEditModal"
            :selected_retailer="selected_retailer"
            @completeTransaction="completeTransaction"
            @cancelTransaction="cancelTransaction"

        />

    <delete_customer_account_model
        v-if="showDeleteCustomerAccount"
        :selected_customer="selected_customer"
        @completeTransaction_delete_customer_account="completeTransaction_delete_customer_account"
        @cancelTransaction_delete_customer_account="cancelTransaction_delete_customer_account"/>

       <div class="w-full overflow-x-auto mt-6" v-if="searched_personnel.length>0">
         <table class="w-full text-left text-sm">
           <thead>

           <tr class="border-b border-gray-200">
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Business Name</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Name</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Email</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Phone</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Account Type</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Wallet Balance</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Address</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Status</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Country</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">State</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Zone</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">City</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Latitude</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Longitude</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap text-center">Edit</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap text-center">Add Customer Account</th>
             <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap text-center">Delete Customer Account</th>

           </tr>
           </thead>
           <tbody>

             <tr v-for="person in searched_personnel" :key="person.id" class="border-b border-gray-100 hover:bg-gray-50">
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{ person.business_name }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{ person.name }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.email }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.phone }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.type_name }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.wallet }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.address }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.status }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.country }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.state }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.zone }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.city }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.latitude }}</td>
               <td class="px-3 py-3 whitespace-nowrap capitalize">{{  person.longitude }}</td>
               <td class="px-3 py-3 text-center"> <button v-if="isAdmin &&  person.type_name === 'retailer' " @click="select_retailer(person)" class="rounded-lg px-3 py-1.5 text-xs font-medium text-white bg-express hover:bg-expressbutton transition-colors"> Edit </button> <div v-else> <i class="fas fa-ban text-gray-300"></i> </div> </td>
               <td class="px-3 py-3 text-center"> <button v-if="isAdmin &&  person.type_name === 'retailer' " @click="add_customer_account(person)" class="rounded-lg px-3 py-1.5 text-xs font-medium text-white bg-green-600 hover:bg-green-700 transition-colors"> Add </button> <div v-else> <i class="fas fa-ban text-gray-300"></i> </div> </td>
               <td class="px-3 py-3 text-center"> <button v-if="isAdmin &&  person.type_name === 'customer' " @click="delete_customer_account(person)" class="rounded-lg px-3 py-1.5 text-xs font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"> Delete </button> <div v-else> <i class="fas fa-ban text-gray-300"></i> </div> </td>

             </tr>

           </tbody>
         </table>

       </div>
       <div v-else class="mt-6 text-expressgray">
         <h1>No Results found</h1>
       </div>
<!--      <table-lite-->
<!--          :has-checkbox="false"-->
<!--          :is-loading="loading"-->
<!--          :is-re-search="isReSearch"-->
<!--          :columns="columns"-->
<!--          :rows="searched_personnel"-->
<!--          :total="searched_personnel.length"-->
<!--      ></table-lite>-->

  </div>
</template>

<script>

import edit_retailer_model from "@/components/uicomponents/models/edit_retailer_model";
import add_customer_account_model from "@/components/uicomponents/models/add_customer_account_model";
import delete_customer_account_model from "@/components/uicomponents/models/delete_customer_account_model";
import {mapGetters} from "vuex";

export default {
 name: "SearchView",
  components: {
    edit_retailer_model,
    add_customer_account_model,
    delete_customer_account_model
  },
  created(){
    console.log("searched_personnel",this.searched_personnel)
  },
  props:["search_value"],
  data(){
    return {
      loading:false,
      isReSearch:false,
      showRetailerEditModal: false,
      showAddCustomerAccount:false,
      showDeleteCustomerAccount: false,
      selected_retailer:{},
      selected_customer:{},
      columns: [
        {
          label: "Name",
          field: "name",
          width: "5%",
          sortable: false,
          isKey: false,
        },
        {
          label: "Email",
          field: "email",
          width: "10%",
          sortable: false,
        },
        {
          label: "Mobile",
          field: "phone",
          width: "5%",
          sortable: false,
        },
        {
          label: "Business Name",
          field: "business_name",
          width: "5%",
          sortable: false,
        },
        {
          label: "Wallet Balance",
          field: "wallet",
          width: "15%",
          sortable: false,
        },
        {
          label: "Account Type",
          field: "type_name",
          width: "5%",
          sortable: false,
        },
        {
          label: "Account Status",
          field: "status",
          width: "5%",
          sortable: false,
        },
        {
          label: "Account Type",
          field: "type_name",
          width: "5%",
          sortable: false,
        },
        {
          label: "Registered",
          field: "created_at",
          width: "5%",
          sortable: false,
        },
        {
          label: "Address",
          field: "address",
          width: "40%",
          sortable: false,
        },

      ],
      totalRecordCount: 2,
      sortable: {
        order: "id,name",
        sort: "asc",
      },

    }
 },
  methods:{
   reload_page(){
     this.$forceUpdate();
   },
   add_customer_account(retailer){
     this.selected_retailer = retailer
     this.showAddCustomerAccount  = true
   },
    delete_customer_account(customer){
      this.selected_customer = customer
      this.showDeleteCustomerAccount  = true
    },
   select_retailer(retaier){

     this.selected_retailer = retaier
     this.showRetailerEditModal  = true

   },

    toogleShowEditModal(){
      this.showRetailerEditModal  = true
    },
    completeTransaction_delete_customer_account(data){
      console.log("completeTransaction_delete_customer_account", data)
      this.$store.dispatch('retailers/action_delete_customer_account',{
        data:data,
        toast:this.$toast,
        router:this.$router
      });
      this.showDeleteCustomerAccount = false
      this.reload_page()
    },
    cancelTransaction_delete_customer_account(){
      this.showDeleteCustomerAccount = false
    },

    completeTransaction_add_customer_account(data){
      console.log("completeTransaction_add_customer_account", data)
      this.$store.dispatch('retailers/action_add_customer_account',{
        data:data,
        toast:this.$toast,
        router:this.$router
      });


      this.showAddCustomerAccount = false
    },
    cancelTransaction_add_customer_account(){
      this.showAddCustomerAccount = false
    },
    completeTransaction(data){
     // console.log("retailer edit transaction data",data)
      this.$store.dispatch('retailers/action_update_retailer_information',{
        data:data,
        toast:this.$toast,
        router:this.$router
      });

      this.showRetailerEditModal = false
    },
    cancelTransaction(){
      this.showRetailerEditModal = false
    }
  },
  computed:{
   isAdmin: function (){
     let checkadmin = false
       this.user.account_types.map(o=>{
        if(o.name === "super_administrator"){
          checkadmin = true
        }
     })
     return checkadmin
   },
    ...mapGetters({
      user: 'authentication/getUser',
      searched_personnel: 'admins/searched_personnel'
      // products: 'products/products'
    }),
  }
}
</script>

<style>

</style>
